(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('timePicker', function(dateUtil) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl(element, attr) {
            let base = 'partials';
            if (attr.templateVersion) {
                return `${base}/booking/template?name=TimePicker&version=${attr.templateVersion}`;
            }
            return `${base}/home/directivetemplate?type=TimePicker`;
        },
        scope: {
            value: '=',
            timeLabelKey: '@',
            timeErrorMessage: '@',
            currentDate: '=',
            maxDate: '=',
            minDate: '=',
            defaultTime: '=',
            isDisabled: '=',
            isTimeApprovedByCustomer: '=?',
            requiresTimeApproval: '=?',
            isRequired: '@'
        },
        controllerAs: 'tp',
        controller() {
            this.focusTrackerHours = {};
            this.focusTrackerMinutes = {};
        },
        link(scope) {
            const minuteSkip = 5;
            scope.value = { };
            scope.ownButton = scope.ownButton === 'true';
            scope.vm = {};

            function times(num1, num2, fn) {
                for (let i = num1; i <= num2; i++) {
                    fn(i);
                }
            }
            function frontPad(num) {
                return num < 10 ? `0${num}` : `${num}`;
            }

            function roundMinutes(mins) {
                if (scope.defaultTime && scope.defaultTime.minutes === mins) {
                    return mins;
                }
                return minuteSkip * Math.round(mins / minuteSkip) % 60;
            }

            scope.h = [];
            scope.m = [];

            if (scope.maxDate && scope.minDate && dateUtil.sameDay(scope.maxDate, scope.minDate)) {
                times(scope.minDate.getHours(), scope.maxDate.getHours(), function(i) {
                    scope.h.push(frontPad(i));
                });
            } else {
                times(0, 23, function(i) {
                    scope.h.push(frontPad(i));
                });
            }
            times(0, 11, function(i) {
                const m = i * minuteSkip;
                scope.m.push(frontPad(m));
            });
            if (scope.defaultTime && scope.defaultTime.minutes % minuteSkip) {
                let i = 0;
                while (i < scope.m.length) {
                    if (scope.m[i] > scope.defaultTime.minutes) {
                        break;
                    }
                    i++;
                }
                scope.m.splice(i, 0, frontPad(scope.defaultTime.minutes));
            }

            // `currentDate` may be initialised by parent scopes async
            const unwatchInit = scope.$watch('currentDate', (v, o) => {
                if (v) {
                    //reset default time only if date has changed
                    let resetDefaultTime = true;
                    if (o) {
                        resetDefaultTime = !(dateUtil.sameDay(v, o));
                    }
                    const date = dateUtil.parseDate(v);
                    if (dateUtil.isValid(date)) {
                        setTime(date);
                        // set hour and minute range
                        //setMinuteRange();
                        if (scope.maxDate && scope.minDate) {
                            setMinuteRange();
                            setTimeRange(resetDefaultTime);
                        } else {
                            // Remove watch on first value
                            unwatchInit();
                        }
                    }
                } else {
                    // Initialise with default
                    setDefaultTime();
                }
            });

            scope.$watch(() => ({
                    isTimeApprovedByCustomer: scope.isTimeApprovedByCustomer,
                    requiresTimeApproval: scope.requiresTimeApproval,
                    vm: scope.vm,
                    value: scope.value
                }),
                (next, old) => {
                    const sync = () => {
                        if (next.vm.hours && next.vm.minutes && !angular.equals(next.vm, old.vm)) {
                            scope.vm.hours = scope.value.hours = next.vm.hours;
                            scope.vm.minutes = scope.value.minutes = next.vm.minutes;
                            return;
                        }
                        if (next.value.hours && next.value.minutes && !angular.equals(next.value, old.value)) {
                            scope.vm.hours = scope.value.hours = next.value.hours;
                            scope.vm.minutes = scope.value.minutes = next.value.minutes;
                        }
                    };

                    if (!next.requiresTimeApproval) {
                        sync();
                        return;
                    }

                    if (!next.isTimeApprovedByCustomer && !old.requiresTimeApproval) {
                        delete scope.vm.hours;
                        delete scope.value.hours;
                        delete next.vm.hours;
                        delete next.value.hours;
                        delete scope.vm.minutes;
                        delete scope.value.minutes;
                        delete next.vm.minutes;
                        delete next.value.minutes;
                        return;
                    }

                    scope.isTimeApprovedByCustomer = next.isTimeApprovedByCustomer || !!(next.vm.hours && next.vm.minutes);

                    if (scope.isTimeApprovedByCustomer) {
                        sync();
                    }
                }, true);

            function setDefaultTime() {
                const date = new Date();
                if (scope.defaultTime) {
                    date.setHours(scope.defaultTime.hours, scope.defaultTime.minutes);
                } else {
                    date.setHours(11, 30);
                }
                setTime(date);
            }

            function setTime(dateOb) {
                scope.$evalAsync(() => {
                    scope.value.hours = frontPad(dateOb.getHours());
                    scope.value.minutes = frontPad(roundMinutes(dateOb.getMinutes()));
                });
            }

            function setMinuteRange() {
                scope.m = [];
                const date = dateUtil.parseDate(scope.currentDate);
                if (scope.minDate.getHours() === date.getHours()) {
                    times(scope.minDate.getMinutes() / minuteSkip, 11, function(i) {
                        const m = i * minuteSkip;
                        scope.m.push(frontPad(m));
                    });
                    scope.value.minutes = scope.minDate.getMinutes();
                } else if (scope.maxDate.getHours() === date.getHours()) {
                    times(0, scope.maxDate.getMinutes() / minuteSkip, function(i) {
                        const m = i * minuteSkip;
                        scope.m.push(frontPad(m));
                    });
                    scope.value.minutes = scope.maxDate.getMinutes();
                } else {
                    times(0, 11, function(i) {
                        const m = i * minuteSkip;
                        scope.m.push(frontPad(m));
                    });
                    scope.value.minutes = 0;
                }
            }

            function setTimeRange(resetDefaultTime) {
                if (!(dateUtil.sameDay(scope.maxDate, scope.minDate))) {
                    scope.h = [];
                    if (dateUtil.sameDay(scope.currentDate, scope.minDate)) {
                        times(scope.minDate.getHours(), 23, function(i) {
                            scope.h.push(frontPad(i));
                        });
                        if (resetDefaultTime) {
                            setTime(scope.minDate);
                        }
                    } else if (dateUtil.sameDay(scope.currentDate, scope.maxDate)) {
                        times(0, scope.maxDate.getHours(), function(i) {
                            scope.h.push(frontPad(i));
                        });
                        if (resetDefaultTime) {
                            setTime(scope.maxDate);
                        }
                    }
                }
            }
        }
    };
});
})();
